var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgChevronDown20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.167 7.278a.75.75 0 0 1 1.055-.11L10 11.034l4.778-3.868a.75.75 0 0 1 .944 1.166l-5.25 4.25a.75.75 0 0 1-.944 0l-5.25-4.25a.75.75 0 0 1-.11-1.055Z",
  clipRule: "evenodd"
})));
export { SvgChevronDown20 as ReactComponent };